// Job statuses and error codes that bpm-lambdas writes (slides/slidesv2/slideJobStore.ts).
export const SlideJobStatus = {
  QUEUED: 'queued',
  RUNNING: 'running',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
} as const;
export type SlideJobStatusType = (typeof SlideJobStatus)[keyof typeof SlideJobStatus];

export const SlideJobErrorCode = {
  GENERATION_FAILED: 'GENERATION_FAILED',
  INVOKE_FAILED: 'INVOKE_FAILED',
  WORKER_TIMEOUT: 'WORKER_TIMEOUT'
} as const;

export type SlideJobWarning =
  | { type: 'SKIPPED_CONTENT'; slideId: string; dynamicContentName: string }
  | { type: 'CHART_NOT_RELINKED'; slideId: string; chartId: number; reason: string };

// Body of GET /slides/getPresentationStatus (bpm-lambdas slides/slidesv2/getPresentationStatus.ts).
export interface PresentationStatus {
  jobId: string;
  status: SlideJobStatusType;
  company: string;
  blueprintId: number;
  configId: number | null;
  source: string;
  presentationId: string | null;
  spreadsheetId: string | null;
  presentationUrl: string | null;
  warnings: SlideJobWarning[];
  errorCode: string | null;
  errorMessage: string | null;
  attempts: number;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
}

export const PRESENTATION_STATUS_POLL_INTERVAL_MS = 5 * 1000;
// The server expires a running job 16 minutes after it starts (RUNNING_EXPIRY_MINUTES in
// slideJobStore.ts) and writes WORKER_TIMEOUT on the next status read. The job starts less than a
// second after the dialog opens, so polling continues one minute more to read that final status.
// Polling stops at the first response this long after the dialog opens.
const SERVER_RUNNING_EXPIRY_MINUTES = 16;
export const PRESENTATION_STATUS_POLL_LIMIT_MS = (SERVER_RUNNING_EXPIRY_MINUTES + 1) * 60 * 1000;

export const GenerationDialogState = {
  // The generatePresentation response had no jobId, so there is nothing to poll.
  NO_JOB_ID: 'no-job-id',
  QUEUED: 'queued',
  RUNNING: 'running',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  // Failed with WORKER_TIMEOUT: the server expired a job that did not finish in time.
  EXPIRED: 'expired',
  // Polling hit its limit before a final status, or the status request fails and no status
  // arrived yet.
  UNKNOWN: 'unknown'
} as const;
export type GenerationDialogStateType =
  (typeof GenerationDialogState)[keyof typeof GenerationDialogState];
